package com.jingfangpai.common.data.type

import com.jingfangpai.common.data.serializer.DateTimeSerializer
import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable

@Serializable(with = DateTimeSerializer::class)
actual class DateTime actual constructor(): Any() {
    @Contextual
    var realDateTime = kotlin.js.Date();
    actual fun getTime(): Long {
        return realDateTime.getTime().toLong()
    }
    actual constructor(time: Long) : this() {
        realDateTime = kotlin.js.Date(time)
    }

    actual constructor(dateString: String) : this() {
        realDateTime = kotlin.js.Date(dateString)
    }

    actual fun toDateString():String {
        return toDateString("-");
    }
    actual fun toDateTimeString():String {
        return toDateTimeString("-");
    }
    actual fun toDateString(separator:String):String {
        val month = "${realDateTime.getMonth() + 1}".padStart(2,'0')
        val date =  "${realDateTime.getDate()}".padStart(2,'0')
        return "${realDateTime.getFullYear()}${separator}${month}${separator}${date}"
    }
    actual fun toDateTimeString(separator:String):String {
        val years = "${realDateTime.getFullYear()}"
        val month = "${realDateTime.getMonth() + 1}".padStart(2,'0')
        val date =  "${realDateTime.getDate()}".padStart(2,'0')
        val hours = "${realDateTime.getHours()}".padStart(2,'0')
        val minutes = "${realDateTime.getMinutes()}".padStart(2,'0')
        val seconds = "${realDateTime.getSeconds()}".padStart(2,'0')
        return "${realDateTime.getFullYear()}${separator}${month}${separator}${date} ${hours}:${minutes}:${seconds}"
    }
    actual fun toDateTimeStringWithoutSecond():String {
        val years = "${realDateTime.getFullYear()}"
        val month = "${realDateTime.getMonth() + 1}".padStart(2,'0')
        val date =  "${realDateTime.getDate()}".padStart(2,'0')
        val hours = "${realDateTime.getHours()}".padStart(2,'0')
        val minutes = "${realDateTime.getMinutes()}".padStart(2,'0')
        return "${realDateTime.getFullYear()}-${month}-${date} ${hours}:${minutes}"
    }
    actual fun toTimeStringWithoutSecond():String {
        val hours = "${realDateTime.getHours()}".padStart(2,'0')
        val minutes = "${realDateTime.getMinutes()}".padStart(2,'0')
        return "${hours}:${minutes}"
    }
    actual fun toTime():Time{
        return Time(getTime());
    }
}
